module.exports = __webpack_public_path__ + "fonts/Graphik-Regular-Web.a3f26d0.woff";